module.exports = __webpack_public_path__ + "static/media/rates.4e51d25b.svg";